<template>
  <div class="collection-ape-traits">
    <RouterLink
      class="collection-ape-traits__lootbox"
      :to="{ name: 'LootBox' }"
    >
      Visit the Loot Box Store
    </RouterLink>
    <h2>Ape Traits</h2>

    <div class="collection-ape-traits-filters">
      <div
        v-for="(item, idx) in filterItems "
        :key="idx"
        class="collection-ape-traits-filters__item"
        :class="{ active: genderFilter === item.value }"
        @click.prevent="selectFilter(item.value)"
      >
        {{ item.name }}
      </div>
    </div>
    <div
      v-if="!isLoading && filteredItems.length"
      class="collection-ape-traits__items"
    >
      <div
        v-for="item in filteredItems"
        :key="item.id"
        class="collection-ape-traits__item"
      >
        <CollectionApeTrait
          :item="item"
          @zoom="onZoom"
        />
      </div>
    </div>
    <div
      v-else-if="!isLoading && !filteredItems.length"
      class="collection-ape-traits__empty"
    >
      You don't have any Traits yet
    </div>
    <div
      v-else
      class="collection-ape-traits__loading"
    >
      <img
        src="@/assets/img/spinner-clear.svg"
        class="spinner"
        width="80"
      >
    </div>
    <Transition name="t-collection-ape-traits-zoom">
      <div
        v-if="showZoom"
        class="collection-ape-traits-zoom"
        @click.prevent="hideZoom"
      >
        <div class="collection-ape-traits-zoom__image">
          <img
            :src="zoomImage"
            alt="zoom-image"
          >
        </div>
      </div>
    </Transition>
  </div>
</template>
<script>
import { useWalletCollectionStore } from "@/store/wallet-collection"
import { computed, defineComponent, ref } from "vue"
import CollectionApeTrait from "./CollectionApeTrait.vue"
export default defineComponent({
    components: { CollectionApeTrait },
    setup() {
        const walletCollection = useWalletCollectionStore()
        const isLoading = ref(false)
        const genderFilter = ref(0)
        const init = async () => {
            isLoading.value = true
            await walletCollection.fetchApeTraits()
            isLoading.value = false
        }
        init()
        const items = computed(() => walletCollection.apeTraits)
        const filterItems = [
            {
                name: "All",
                value: 0
            },
            {
                name: "Male",
                value: 1,
            },
            {
                name: "Female",
                value: 2
            },
            {
                name: "Unisex",
                value: 3
            },
        ]
        const selectFilter = (value) => {
            genderFilter.value = value
        }
        const showZoom = ref(false)
        const zoomImage = ref('')
        const onZoom = image => {
            zoomImage.value = image
            showZoom.value = true
        }
        const hideZoom = () => {
            showZoom.value = false
        }
        const filteredItems = computed(() => items.value.filter(item => genderFilter.value ? item.genderId === genderFilter.value : true))
        return {
            items, isLoading, showZoom, zoomImage, genderFilter, hideZoom, onZoom, selectFilter, filterItems, filteredItems
        }
    }
})
</script>
<style lang="scss">
.collection-ape-traits {
    width: 90%;
    margin: 0 auto;
    position: relative;
    &__items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -10px;
        margin-top: 40px;
    }
    &__empty {
        padding: 30px 0;
        font-size: 18px;
        text-transform: uppercase;
        font-weight: bold;
    }
    &__item {
        width: calc(100% / 5);
        padding: 15px 10px;
        box-sizing: border-box;
    }
    &__lootbox {
        padding: 8px 16px;
        background-color: var(--primary);
        color: #fff;
        border-radius: 5px;
        text-decoration: none;
        box-sizing: border-box;
        display: block;
        font-weight: bold;
        text-transform: uppercase;
        transition: 0.2s;
        position: absolute;
        right: 0;

        transform: translateY(-50px);

        &:hover {
            filter: brightness(0.8);
        }
    }
    &-filters {
        display: flex;
        justify-content: center;
        &__item {
            width: 100px;
            padding: 5px;
            border: 1px solid var(--border);
            border-left: none;
            box-sizing: border-box;
            cursor: pointer;
            &.active {
                background-color: var(--primary);
            }
            &:last-child {
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
            }
            &:first-child {
                border-left: 1px solid var(--border);

                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
            }
        }
    }

    &__loading {
        padding: 50px 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &-zoom {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        z-index: 30;
        background-color: rgba(0, 0, 0, 0.5);
        transition: 0.2s;
        &__image {
            img {
                transition: 0.2s;
                object-fit: contain;
                width: 90%;
                margin-top: 30px;
                max-width: 800px;
                max-height: 80%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }
    .t-collection-ape-traits-zoom-enter-from,
    .t-collection-ape-traits-zoom-leave-to {
        img {
            transform: translate(-50%, -50%) scale(0.1);
        }
        opacity: 0;
    }
    @media screen and (max-width: 1450px) {
        &__item {
            width: calc(100% / 4);
        }
    }
    @media screen and (max-width: 992px) {
        &__item {
            width: calc(100% / 3);
        }
    }
    @media screen and (max-width: 768px) {
        &__item {
            width: calc(100% / 2);
        }
    }
    @media screen and (max-width: 576px) {
        &__item {
            width: 100%;
        }
        &__lootbox {
            position: relative;
            transform: none;
            margin-top: 30px;
        }
    }
}
</style>